import { useState } from "react";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // Branding zależny od domeny logowania (osobny ekran dla zut.com.pl = Gdańsk).
  // Kolory dopasowane do motywu danego panelu, na który trafia użytkownik.
  const isZut =
    typeof window !== "undefined" &&
    window.location.hostname.endsWith("zut.com.pl");

  const themes = {
    // Domyślny motyw Vulpix (pomarańczowy)
    vulpix: {
      logo: "/vulpix.png",
      alt: "Vulpix Logo",
      title: "Logowanie",
      pageBg: "linear-gradient(180deg, #ffe5b4 0%, #ffd19a 100%)",
      pageColor: "#5c3200",
      card: "rgba(255, 247, 235, 0.92)",
      cardShadow: "0 8px 25px rgba(255, 140, 0, 0.3)",
      logoGlow: "drop-shadow(0 0 6px rgba(255, 140, 0, 0.4))",
      titleColor: "#c25400",
      titleShadow: "0 1px 3px rgba(255, 170, 70, 0.4)",
      inputBg: "#fff9f0",
      inputBorder: "1px solid rgba(255, 150, 50, 0.6)",
      inputBorderFocus: "1px solid rgba(255, 160, 60, 0.9)",
      btnBg: "linear-gradient(90deg, #ff8c00, #ffa733)",
      btnShadow: "0 4px 15px rgba(255, 140, 0, 0.4)",
      btnShadowHover: "0 6px 20px rgba(255, 150, 40, 0.6)",
    },
    // Motyw Gdańsk (niebieski, spójny z dashboardem zut.com.pl)
    gdansk: {
      logo: "/logo_gdansk.svg",
      alt: "Sortownia AI",
      title: "Sortownia AI",
      pageBg: "linear-gradient(180deg, #eef6ff 0%, #dbeeff 100%)",
      pageColor: "#0f172a",
      card: "rgba(255, 255, 255, 0.82)",
      cardShadow: "0 8px 25px rgba(37, 99, 235, 0.22)",
      logoGlow: "drop-shadow(0 0 6px rgba(56, 189, 248, 0.45))",
      titleColor: "#0077ae",
      titleShadow: "0 1px 3px rgba(96, 165, 250, 0.4)",
      inputBg: "#f6fbff",
      inputBorder: "1px solid rgba(37, 99, 235, 0.30)",
      inputBorderFocus: "1px solid rgba(56, 189, 248, 0.9)",
      btnBg: "linear-gradient(90deg, #0077ae, #38bdf8)",
      btnShadow: "0 4px 15px rgba(37, 99, 235, 0.4)",
      btnShadowHover: "0 6px 20px rgba(56, 189, 248, 0.6)",
    },
  };
  const brand = isZut ? themes.gdansk : themes.vulpix;

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("/auth/login", {

        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          username: username,
          password: password
  }),
  credentials: "include"  // ← WAŻNE!
});

      if (res.ok) {
        const data = await res.json();


        const location = data.location;
        if (!location) {
          setError("Brak przypisanej lokalizacji użytkownika");
          return;
        }

        // Redirect na panel w TEJ SAMEJ domenie bazowej co strona logowania:
        // login.zut.com.pl -> gdansk.zut.com.pl, login.vulpix.pl -> gdansk.vulpix.pl
        const base = window.location.hostname.split(".").slice(1).join(".") || "vulpix.pl";
        window.location.href = `https://${location}.${base}/`;
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || "Nieprawidłowy login lub hasło");
      }
    } catch {
      setError("Błąd połączenia z serwerem");
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: brand.pageBg,
        color: brand.pageColor,
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1rem",
          backgroundColor: brand.card,
          padding: "2.5rem 2rem",
          borderRadius: "18px",
          width: "330px",
          boxShadow: brand.cardShadow,
          border: "none",
        }}
      >
        <img
          src={brand.logo}
          alt={brand.alt}
          style={{
            width: "140px",
            marginBottom: "0.5rem",
            filter: brand.logoGlow,
          }}
        />

        <h1
          style={{
            fontSize: "1.6rem",
            fontWeight: "700",
            color: brand.titleColor,
            textShadow: brand.titleShadow,
          }}
        >
          {brand.title}
        </h1>

        <input
          placeholder="Login"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{
            width: "100%",
            padding: "0.7rem",
            borderRadius: "8px",
            border: brand.inputBorder,
            backgroundColor: brand.inputBg,
            outline: "none",
            transition: "0.2s",
          }}
          onFocus={(e) => (e.target.style.border = brand.inputBorderFocus)}
          onBlur={(e) => (e.target.style.border = brand.inputBorder)}
        />

        <input
          placeholder="Hasło"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: "100%",
            padding: "0.7rem",
            borderRadius: "8px",
            border: brand.inputBorder,
            backgroundColor: brand.inputBg,
            outline: "none",
            transition: "0.2s",
          }}
          onFocus={(e) => (e.target.style.border = brand.inputBorderFocus)}
          onBlur={(e) => (e.target.style.border = brand.inputBorder)}
        />

        {error && (
          <p
            style={{
              color: "#d32f2f",
              fontSize: "0.9rem",
              textAlign: "center",
            }}
          >
            {error}
          </p>
        )}

        <button
          type="submit"
          style={{
            background: brand.btnBg,
            color: "#fff",
            padding: "0.7rem",
            width: "100%",
            borderRadius: "8px",
            border: "none",
            fontWeight: "600",
            cursor: "pointer",
            fontSize: "1rem",
            boxShadow: brand.btnShadow,
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "scale(1.03)";
            e.target.style.boxShadow = brand.btnShadowHover;
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "scale(1)";
            e.target.style.boxShadow = brand.btnShadow;
          }}
        >
          Zaloguj
        </button>
      </form>
    </div>
  );
}
